(function(angular, module) {var StudentListCacheService,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

StudentListCacheService = (function() {

  /* @ngInject */
  function StudentListCacheService($state, localStorageService) {
    this.stateChangeStart = bind(this.stateChangeStart, this);
    this.state = $state;
    this.localStorage = localStorageService;
    this.statesToMonitor = {};
    this.cachedParams = {};
  }

  StudentListCacheService.prototype.monitorState = function(stateName, uniqueId) {
    this.statesToMonitor[stateName] = uniqueId;
  };

  StudentListCacheService.prototype.localStorageKey = function(stateName) {
    return "param_cache." + stateName;
  };

  StudentListCacheService.prototype.storeParams = function(stateName, params) {
    this.cachedParams[stateName] = params;
    this.localStorage.set(this.localStorageKey(stateName), params);
  };

  StudentListCacheService.prototype.getParams = function(stateName) {
    var key, stored;
    if (!this.cachedParams[stateName]) {
      key = this.localStorageKey(stateName);
      stored = this.localStorage.get(key);
      this.cachedParams[stateName] = stored;
    }
    return angular.copy(this.cachedParams[stateName]);
  };

  StudentListCacheService.prototype.restoreParams = function(stateName, params) {
    var idName, newParams;
    newParams = this.getParams(stateName);
    idName = this.statesToMonitor[stateName];
    if (!newParams) {
      this.storeParams(stateName, params);
      params.noRestore = true;
      return params;
    } else if (newParams[idName] !== params[idName]) {
      newParams[idName] = params[idName];
      newParams.noRestore = true;
      newParams.page = 1;
      newParams.search = "";
      return newParams;
    } else {
      newParams.noRestore = true;
      return newParams;
    }
  };

  StudentListCacheService.prototype.isMonitored = function(state) {
    return !!this.statesToMonitor[state.name];
  };

  StudentListCacheService.prototype.stateChangeStart = function(event, toState, toParams, fromState, fromParams) {
    if (toState.name === fromState.name) {
      return;
    }
    this.leaveState(event, fromState, fromParams);
    this.enterState(event, toState, toParams, fromState);
  };

  StudentListCacheService.prototype.leaveState = function(event, state, params) {
    if (!this.isMonitored(state)) {
      return;
    }
    this.storeParams(state.name, params);
  };

  StudentListCacheService.prototype.enterState = function(event, state, params, fromState) {
    var newParams;
    if (!this.isMonitored(state)) {
      return;
    }
    if (params.noRestore) {
      return;
    }
    newParams = this.restoreParams(state.name, params);
    event.preventDefault();
    return this.state.go(state.name, newParams);
  };


  /* @ngInject */

  StudentListCacheService.config = function($rootScope, StudentListCache) {
    $rootScope.$on('$stateChangeStart', StudentListCache.stateChangeStart);
    StudentListCache.monitorState('students', 'slug');
    StudentListCache.monitorState('participants', 'slug');
  };

  return StudentListCacheService;

})();

module.service('StudentListCache', StudentListCacheService).run(StudentListCacheService.config);
})(angular, angular.module("dyb.students.overview"));